var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1488_14027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.81426H19C20.0609 8.81426 21.0783 9.23203 21.8284 9.97567C22.5786 10.7193 23 11.7279 23 12.7796C23 13.8312 22.5786 14.8398 21.8284 15.5834C21.0783 16.3271 20.0609 16.7449 19 16.7449H18M18 8.81426H2V17.7362C2 18.7878 2.42143 19.7964 3.17157 20.5401C3.92172 21.2837 4.93913 21.7015 6 21.7015H14C15.0609 21.7015 16.0783 21.2837 16.8284 20.5401C17.5786 19.7964 18 18.7878 18 17.7362V8.81426ZM6 1.875V4.84897M10 1.875V4.84897M14 1.875V4.84897",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1488_14027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.7918,
    fill: "white",
    transform: "translate(0 0.883789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/Coffee.c3d636d385c7ef02f63684eaa3884023.svg";
export { ForwardRef as ReactComponent };